import { Icon } from "@zapier/design-system";
import { Wrapper } from "./components";

export function StandardBlockErrorState() {
  return (
    <Wrapper className="flex-col items-center p-12">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-zi-pageBackground text-zi-primary">
        <Icon name="alertTriangle" color="currentColor" size={34} isBlock />
      </div>
      <div className="mb-3 mt-5 text-base font-bold">Something is amiss</div>
      <div className="text-sm">
        This component is not configured appropriately.
      </div>
    </Wrapper>
  );
}
